"use server";

import { requireServerRole } from "@/lib/guards";
import {
  addNonVwfsLessorSchema,
  editNonVwfsLessorSchema,
  deleteNonVwfsLessorSchema,
} from "@/lib/schemas/non-vwfs-lessors";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteNonVwfsLessor(
  params: z.infer<typeof deleteNonVwfsLessorSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteNonVwfsLessorSchema, params);

    await prisma.nonVwfsLessor.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addNonVwfsLessor(
  params: z.infer<typeof addNonVwfsLessorSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { name, siret } = validateParams(addNonVwfsLessorSchema, params);

    const nonVwfsLessor = await prisma.nonVwfsLessor.create({
      data: { name, siret, isActive: true },
    });

    return { success: true, data: nonVwfsLessor };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editNonVwfsLessor(
  params: z.infer<typeof editNonVwfsLessorSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      name,
      siret,
      isActive = true,
    } = validateParams(editNonVwfsLessorSchema, params);

    const nonVwfsLessor = await prisma.nonVwfsLessor.update({
      where: { id },
      data: { name, isActive, siret },
    });

    return { success: true, data: nonVwfsLessor };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
